// noinspection BadExpressionStatementJS

import React, {SFC, useEffect, useState, useLayoutEffect} from "react";
import { Redirect, useHistory } from "react-router-dom";
import API from "../../helpers/apiHelpers";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import {createUserProfile, getUserProfile} from "../../redux/userProfile/userProfile.actions";
import moment from "moment-timezone";
import {createPartner, getBranding, updatePartner} from "../../redux/branding/branding.actions";
import {useLocation} from "react-router";
import {useSnackbar} from "notistack";
import WebFont from "webfontloader";

interface Props {
	isOnBoarding: boolean;
}
const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const IsOnBoardingCheck: SFC<Props> = ({isOnBoarding=false}: Props) => {
    const role = useSelector((state: RootState) => state?.user.role);
    const path = useLocation();
    const history = useHistory();
    const query = useQuery();
    const dispatch = useAppDispatch();
    const [loaded,setLoaded] = useState(false);
    const [brandingLoad, setBrandingLoad] = useState(false);
    const partnerId = query.get("partnerId");
    const isLogOut = useSelector((state: RootState) => state?.common.isLogOut);
    const { enqueueSnackbar } = useSnackbar();

    useLayoutEffect(() => {
        (async () => {
            if (partnerId) {
                const link = document.querySelector("link[rel='icon']");
                // @ts-ignore
                link.href = link.getAttribute("data-ico-label");
                await dispatch(getBranding(partnerId)).then((res) => {
                    WebFont.load({
                        google: {
                            families: [res.font?.header, res.font?.text]
                        }
                    });
                    setBrandingLoad(true);
                }
                )
                    .catch(err => {
                        enqueueSnackbar("Can not find partner by given id", {
                            variant: "error",
                            autoHideDuration: 3000
                        });
                        setBrandingLoad(true);
                    }
                    );
            }
        })();
    }, []);
    useEffect(() => {
        const runConfirmCheck = async () => {
            if (window.sessionStorage.getItem("specialParams") && !isLogOut){
                history.push(`/${window.sessionStorage.getItem("specialParams")}`);
            }
            const auth = JSON.parse(localStorage.getItem("auth"));
            if(auth) {
                const {userId, role} = auth;
                try {
                    if (role === "VET" || role === "OWNER") {
                        const profiles = await dispatch(getUserProfile({userId}));
                        if (!profiles?.length) {
                            await API.postAgreement({type: "registration_tos", userId});
                            await API.postAgreement({type: "registration_privacy", userId});
                            if (role === "VET") {
                                const profile = JSON.parse(localStorage.getItem("profile"));
                                await dispatch(createUserProfile({
                                    userId: userId,
                                    firstName: profile?.firstName,
                                    lastName: profile?.lastName,
                                    practiceCode: profile?.practiceCode,
                                    type: "vet",
                                    locationTimeZone: moment.tz.guess(),
                                    workDays: [
                                        {
                                            workdayBegins: moment().toISOString(),
                                            workdayEnds: moment().add(3, "hours").toISOString()
                                        }
                                    ]
                                }));
                            }
                            setLoaded(true);
                        }
                    } else if (role === "PARTNER") {
                        const partnerData = JSON.parse(localStorage.getItem("partner"));
                        if (partnerData) {
                            const {name, creatorId, subscription, url} = partnerData;
                            const partner = await dispatch(createPartner({
                                creatorId,
                                name,
                                subscription,
                                url: ""
                            }));
                            await dispatch(updatePartner({
                                id: partner.id, body: {
                                    url: `${url}login?partnerId=${partner.id}`,
                                    name: partner.name
                                }
                            }));
                            localStorage.removeItem("partner");
                        }
                    }
                    setLoaded(true);
                } catch (err) {
                    if (err?.status === 403) {
                        if (!!auth.url) {
                            document.location.href = auth.url;
                            localStorage.removeItem("auth");
                        }
                        else {
                            enqueueSnackbar("You do not have access to this partner", {
                                variant: "error",
                                autoHideDuration: 3000
                            });
                            localStorage.removeItem("auth");
                            history.push("/login");
                        }
                        setLoaded(false);
                        return;
                    }
                }
            }
            setLoaded(true);
        };
        runConfirmCheck();
    }, []);
    return(
        <>
            {
                loaded && (!partnerId || brandingLoad) ?
                    <>
                        {
                            role === "OWNER" ?
                                <Redirect to={{pathname: "/schedule", state: path.state}}/>
                                : role === "PARTNER" ?
                                    <Redirect to="/preferences" />
                                    : role === "ADMIN"
                                        ? <Redirect to="/admin/appointments/search" />
                                        : <Redirect to="/appointments" />
                        }
                    </> :
                    <></>
            }
        </>
    );
};

export default IsOnBoardingCheck;
